export const defaultShowProductsButtonModelData = {
  isRendered: false,
  total: null
};

export const defaultCheckboxModelData = {
  hidden: false
};

export const defaultCheckboxesTriggerModelData = {
  expanded: false,
  hiddenCount: 0
};

export const defaultCheckboxesModelData = {
  isActive: true,
  isTitleActive: false
};

export const defaultSliderWrapperModelData = {
  isActive: true
};

export const defaultSliderModelData = {
  isTriggered: false,
  fromValue: 0,
  toValue: 0,
  min: 0,
  max: 0,
  range: 0,
  activeTrigger: null,
  rounding: null,
  isReset: true
};

export const defaultSortingModelData = {
  sortName: null,
  sortDir: null
};

export const defaultViewTypesModelData = {
  activeViewType: null
};

export const defaultInsertModelData = {
  id: null,
  type: null
};

export const defaultResetModelData = {
  isRendered: false
};

export const defaultResponsiveFilterModelData = {
  isButtonRendered: false,
  isStickyButtonRendered: false,
  isFilterRendered: false,
  touchstartPageX: null,
  total: null
};

export const defaultHeadingWrapperModelData = {
  total: null,
  isTotalRendered: false
};

export const VISIBLE_CHECKBOXES_NUMBER = 7;
export const VISIBLE_FIELDSET_NUMBER = 3;

export const ActionType = {
  EXPAND: `EXPAND`,
  SHRINK: `SHRINK`,
  SHOW: `SHOW`,
  HIDE: `HIDE`,
  HANDLER_HOLD: `HANDLER_HOLD`,
  HANDLER_RELEASE: `HANDLER_RELEASE`,
  HANDLER_MOVE: `HANDLER_MOVE`,
  CHANGE_SLIDER_INPUT: `CHANGE_SLIDER_INPUT`,
  CHANGE_VIEW_TYPE: `CHANGE_VIEW_TYPE`,
  SORT: `SORT`,
  ADD_RESET: `ADD_RESET`,
  REMOVE_RESET: `REMOVE_RESET`,
  FORM_RESET: `FORM_RESET`,
  RENDER_FILTER_BUTTON: `RENDER_FILTER_BUTTON`,
  REMOVE_FILTER_BUTTON: `REMOVE_FILTER_BUTTON`,
  RENDER_STICKY_FILTER_BUTTON: `RENDER_STICKY_FILTER_BUTTON`,
  REMOVE_STICKY_FILTER_BUTTON: `REMOVE_STICKY_FILTER_BUTTON`,
  RENDER_RESPONSIVE_FILTER: `RENDER_RESPONSIVE_FILTER`,
  DESTROY_RESPONSIVE_FILTER: `DESTROY_RESPONSIVE_FILTER`,
  BROWSER_NAVIGATE: `BROWSER_NAVIGATE`,
  LOAD_START: `LOAD_START`,
  LOAD_END: `LOAD_END`,
  RENDER_SHOW_PRODUCTS_BUTTON: `RENDER_SHOW_PRODUCTS_BUTTON`,
  ACTIVATE_FIELDSET: `ACTIVATE_FIELDSET`,
  DEACTIVATE_FIELDSET: `DEACTIVATE_FIELDSET`,
  ACTIVATE_FIELDSET_TITLE: `ACTIVATE_FIELDSET_TITLE`,
  DEACTIVATE_FIELDSET_TITLE: `DEACTIVATE_FIELDSET_TITLE`,
  CHANGE_TOTAL: `CHANGE_TOTAL`,
  SHOW_TOTAL: `SHOW_TOTAL`,
  HIDE_TOTAL: `HIDE_TOTAL`
};

export const SliderTrigger = {
  FROM: `from`,
  TO: `to`
};

export const RequestMethod = {
  POST: `POST`,
  GET: `GET`
};

export const CONNECTOR_URL = `/assets/components/categoryfilter/connector.php`;

export const RequestAction = {
  LOAD_PRODUCTS: `load_products`,
  LOAD_INSERTS: `load_inserts`,
  GET_TOTAL: `get_total`
};

export const PAGINATION_KEY = `page`;
export const LIMIT_KEY = `limit`;
export const SORT_KEY = `sort`;
export const VIEW_TYPE_KEY = `category_view`;

export const ViewType = {
  CARD: `card`,
  LIST: `list`
};

export const RESET_ANIMATION_DURATION = 200;
export const CHECKBOX_ANIMATION_DURATION = 200;

export const MOBILE_MEDIA_QUERY = `(max-width: 840px)`;

export const KEABOARD_ESC_KEYS = [
  `Escape`,
  `Esc`
];

export const RESPONSIVE_FILTER_TOUCH_THRESHOLD = 80;

export const PROPERTIES_SEPARATOR = `||`;

export const DEBOUNCE_INPUT_TIME = 1000;

export const SortDir = {
  DESC: `desc`,
  ASC: `asc`
};

export const InsertType = {
  VIDEO: `video`,
  BANNER_WITH_QUIZ: `banner_with_quiz`
};

export const QUIZ_SCRIPT_SRC = `//script.marquiz.ru/v2.js`;
export const quizScriptOptions =  {
  host: '//quiz.marquiz.ru',
  region: 'eu',
  id: '63600e5c4c045b004f62fda3',
  autoOpen: false,
  autoOpenFreq: 'once',
  openOnExit: false,
  disableOnMobile: false
};
